import ReactGA from 'react-ga';
import {GOOGLE_ID} from "./api";

ReactGA.initialize(GOOGLE_ID);

export default function pageview(data) {
    ReactGA.pageview(data);
}